import { render, staticRenderFns } from "./LayoutNativeSplashScreen.vue?vue&type=template&id=407a8077&scoped=true&"
import script from "./LayoutNativeSplashScreen.vue?vue&type=script&lang=js&"
export * from "./LayoutNativeSplashScreen.vue?vue&type=script&lang=js&"
import style0 from "./LayoutNativeSplashScreen.vue?vue&type=style&index=0&id=407a8077&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407a8077",
  null
  
)

export default component.exports